<template>
  <div class="login relative">
    <div class="plus-wrapper absolute overflow-hidden">
      <svg
        class="plus"
        width="699"
        height="699"
        viewBox="0 0 699 699"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M698.383 241.704H457.266V0.587463L241.705 0.587463V241.704H0.587402L0.587402 457.267H241.705V698.384H457.266L457.266 457.267L698.383 457.267V241.704Z"
          fill="#303AB2"
          fill-opacity="0.05"
        />
      </svg>
    </div>
    <img
      class="main-logo w-[161px] h-[36px]"
      src="@/assets/images/logo-main.svg"
      alt=""
    />
    <div class="login__left min-h-screen overflow-y-hidden">
      <div id="loginForm" class="login__panelWrapper">
        <div class="login__loginWrapper">
          <div class="title__row">
            <p class="login__title">Login to your account</p>
            <p class="login__description">
              Great to see you again! Please enter your login details
            </p>
          </div>
          <div class="login__area">
            <div class="input__column">
              <Input
                tabindex="1"
                @enter="enter"
                id="email"
                autocomplete="email"
                v-model="email"
                type="email"
                placeholder="Business Email"
              />
            </div>
            <div class="input__colum relative">
              <Input
                tabindex="2"
                @enter="enter"
                id="password"
                autocomplete="password"
                v-model="password"
                placeholder="Password"
                :type="inputTypeIconPassword"
              >
                <button
                  tabindex="3"
                  type="button"
                  class="toggleButtonIcon"
                  @click.prevent="ToggleButtonIconPassword"
                >
                  <img
                    v-if="inputTypeIconPassword == 'password'"
                    src="@/assets/images/eye-on.svg"
                    alt="eye-on"
                  />
                  <img v-else src="@/assets/images/eye-off.svg" alt="eye-off" />
                </button>
              </Input>
            </div>
            <div class="input__column">
              <p class="text-rdc-red text-md">{{ error }}</p>
            </div>
            <div class="input__column">
              <Button @click="signIn" class="default block mt-5">Login</Button>
            </div>
          </div>
          <div class="login__content">
            <p>
              Don’t have an account?
              <router-link :to="{ name: 'Register' }">Sign Up</router-link>
            </p>
            <p>
              <router-link :to="{ name: 'ForgotPassword' }"
                >Forgot Password?</router-link
              >
            </p>
          </div>
        </div>
      </div>
      <a href="https://momentumsuite.com/m-connect" class="momentumsuit-link">
        <img
          class="w-[16.75px] h-[14px]"
          src="@/assets/images/arrow.svg"
          alt=""
        />
        <p>Back</p>
      </a>
    </div>
    <div class="login__right static h-[100vh] relative">
      <img
        class="corner top-0 right-0"
        src="@/assets/images/corner-top.svg"
        alt=""
      />
      <img
        class="corner bottom-0 left-0"
        src="@/assets/images/corner-bottom.svg"
        alt=""
      />
      <div class="login__panelWrapper">
        <div ref="swiper" class="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide flex-col">
              <div class="login__right__slider">
                <img src="@/assets/images/slider-2.svg" alt="" />
                <div class="text-area flex flex-col items-center gap-2">
                  <span class="login__right__title">Browser & App Testing</span>
                  <span class="login__right--description"
                    >Behold the magic of M-Connect!</span
                  >
                  <span class="login__right--description">
                    Unleash your app or web's potential on a grand stage,<br />
                    showcasing it across a diverse ensemble of real mobile
                    devices.</span
                  >
                </div>
              </div>
            </div>
            <div class="swiper-slide flex-col">
              <div class="login__right__slider">
                <img src="@/assets/images/slider-1.svg" alt="" />
                <div class="text-area flex flex-col items-center gap-2">
                  <span class="login__right__title"
                    ><span class="text-[38px] font-light">Choose your</span>
                    real device
                  </span>
                  <span class="login__right--description"
                    >Cover your real conditions with real mobile devices</span
                  >
                  <span class="login__right--description"
                    >M-Connect is a secured and ready-to-use farm whenever
                    you<br />
                    need it before starting your test.</span
                  >
                </div>
              </div>
            </div>

            <div class="swiper-slide flex-col">
              <div class="login__right__slider">
                <img src="@/assets/images/slider-3.svg" alt="" />
                <div class="text-area flex flex-col items-center gap-2">
                  <span class="login__right__title">
                    <span class="text-[38px] font-light">Get more</span>
                    done together
                  </span>
                  <span class="login__right--description"
                    >Simplify Teamwork for Every Stakeholder</span
                  >
                  <span class="login__right--description"
                    >Give your stakeholder control of the same device with
                    you.<br />
                    Manage your participants on your session.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Input from "@/components/Input";
import Button from "@/components/Button";
import { mapActions } from "vuex";
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";

export default {
  name: "Login",
  components: {
    Button,
    Input,
  },
  data() {
    return {
      email: "",
      password: "",
      error: "",
      inputTypeIconPassword: "password",
    };
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: "auto",
      autoHeight: true,
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  },
  methods: {
    ...mapActions(["login"]),
    signIn() {
      this.login({
        email: this.email,
        password: this.password,
      })
        .then(() => {
          this.$router.push({ name: "Devices" });
        })
        .catch(() => {
          this.error = "The email address or password you entered is incorrect";
        });
    },
    enter() {
      this.signIn();
    },
    ToggleButtonIconPassword() {
      this.inputTypeIconPassword =
        this.inputTypeIconPassword === "password" ? "text" : "password";
    },
  },
};
</script>
<style lang="css">
@import "index.module.css";
.login__content a,
.momentumsuit-link p {
  @apply text-primary-base font-bold cursor-pointer;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-pagination {
  position: relative;
  margin-top: 32px;
  bottom: 0px !important;
}
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  background-color: #fff;
  opacity: 0.5;
}
.swiper-pagination-bullet-active {
  border-radius: 50px;
  width: 24px;
  opacity: 1;
}
</style>
